import script from "./GalleryPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPublic.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPublic.vue?vue&type=style&index=0&id=042e5832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042e5832"]])

export default __exports__